// The BOT Store catalogue from MBTSDB (REACT_APP_STORE_FROM_DB_ENABLED, default
// on). /api/store sends every visible bot with its zone and category. Zone A keeps
// its existing presentation (names, icons, descriptions, prices, categories in
// App.js) and only shows services the database also lists; Zones B and C are
// built entirely from the database.
export const STORE_FROM_DB_ENABLED = process.env.REACT_APP_STORE_FROM_DB_ENABLED !== "false";

// bots: [{ name, key, description, price, zone, category }]
// -> { A: { keys: Set }, B: { categories: [..], bots: [..] }, C: { ... } }
export function buildStoreCatalog(bots = []) {
  const catalog = { A: { keys: new Set() }, B: { categories: [], bots: [] }, C: { categories: [], bots: [] }, variants: {} };
  for (const bot of Array.isArray(bots) ? bots : []) {
    if (!bot || !bot.key) continue;
    if (Array.isArray(bot.variants) && bot.variants.length) catalog.variants[bot.key] = { list: bot.variants, defaultVariantId: bot.defaultVariantId };
    if (bot.zone === "A") { catalog.A.keys.add(bot.key); continue; }
    const zone = catalog[bot.zone];
    if (!zone) continue;
    zone.bots.push(bot);
    if (bot.category && !zone.categories.includes(bot.category)) zone.categories.push(bot.category);
  }
  for (const z of ["B", "C"]) catalog[z].categories.sort((a, b) => a.localeCompare(b));
  return catalog;
}

// A BOT's icon variations, and the icon this person sees: their choice, else the
// BOT's default, else null (the caller's usual icon). Same model for channels later.
export const botVariants = (catalog, key) => catalog?.variants?.[key]?.list || [];
export function chosenVariantId(catalog, key, choices) {
  const entry = catalog?.variants?.[key];
  if (!entry) return null;
  const mine = choices && choices[key];
  return entry.list.some((v) => v.variantId === mine) ? mine : entry.defaultVariantId;
}
export function variantIcon(catalog, key, choices) {
  const id = chosenVariantId(catalog, key, choices);
  return botVariants(catalog, key).find((v) => v.variantId === id)?.iconUrl || null;
}

export async function saveBotVariant(userId, pkg, variantId) {
  const res = await fetch("/api/bot-variant", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    credentials: "same-origin",
    body: JSON.stringify({ userId, package: pkg, variantId }),
  });
  return res.ok;
}

export async function loadStoreCatalog() {
  try {
    const res = await fetch("/api/store");
    if (!res.ok) return null;
    const data = await res.json();
    return Array.isArray(data?.bots) ? buildStoreCatalog(data.bots) : null;
  } catch (_) {
    return null;
  }
}

export const botsInCategory = (catalog, zone, category) =>
  (catalog?.[zone]?.bots || []).filter((b) => b.category === category);

export const catalogBot = (catalog, key) =>
  ["B", "C"].map((z) => (catalog?.[z]?.bots || []).find((b) => b.key === key)).find(Boolean) || null;
